import { render, staticRenderFns } from "./DiscreteDataSummary.vue?vue&type=template&id=511e2344"
import script from "./DiscreteDataSummary.vue?vue&type=script&lang=js"
export * from "./DiscreteDataSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports